import { Constants, ParticipantType, PostChatSurveyTelemetryMessage } from "../../../common/Constants";
import { LogLevel, TelemetryEvent } from "../../../common/telemetry/TelemetryConstants";
import { ConversationState } from "../../../contexts/common/ConversationState";
import { LiveChatWidgetActionType } from "../../../contexts/common/LiveChatWidgetActionType";
import { PostChatSurveyMode } from "../../postchatsurveypanestateful/enums/PostChatSurveyMode";
import { TelemetryHelper } from "../../../common/telemetry/TelemetryHelper";
import { addDelayInMs } from "../../../common/utils";
import { isPostChatSurveyEnabled } from "./liveChatConfigUtils";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let conversationDetails = undefined;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let postChatSurveyMode = undefined;
const getBotSurveyMode = (props, state) => {
  var _props$chatConfig, _props$chatConfig$Liv, _state$domainStates$l, _state$domainStates$l2;
  return ((_props$chatConfig = props.chatConfig) === null || _props$chatConfig === void 0 ? void 0 : (_props$chatConfig$Liv = _props$chatConfig.LiveWSAndLiveChatEngJoin) === null || _props$chatConfig$Liv === void 0 ? void 0 : _props$chatConfig$Liv.msdyn_postconversationsurveybotsurveymode) ?? ((_state$domainStates$l = state.domainStates.liveChatConfig) === null || _state$domainStates$l === void 0 ? void 0 : (_state$domainStates$l2 = _state$domainStates$l.LiveWSAndLiveChatEngJoin) === null || _state$domainStates$l2 === void 0 ? void 0 : _state$domainStates$l2.msdyn_postconversationsurveybotsurveymode);
};
const getUserSurveyMode = (props, state) => {
  var _props$chatConfig2, _props$chatConfig2$Li, _props$chatConfig3, _props$chatConfig3$Li;
  if (!((_props$chatConfig2 = props.chatConfig) !== null && _props$chatConfig2 !== void 0 && (_props$chatConfig2$Li = _props$chatConfig2.LiveWSAndLiveChatEngJoin) !== null && _props$chatConfig2$Li !== void 0 && _props$chatConfig2$Li.msdyn_postconversationsurveymode)) {
    var _state$domainStates, _state$domainStates$l3, _state$domainStates$l4;
    return (state === null || state === void 0 ? void 0 : (_state$domainStates = state.domainStates) === null || _state$domainStates === void 0 ? void 0 : (_state$domainStates$l3 = _state$domainStates.liveChatConfig) === null || _state$domainStates$l3 === void 0 ? void 0 : (_state$domainStates$l4 = _state$domainStates$l3.LiveWSAndLiveChatEngJoin) === null || _state$domainStates$l4 === void 0 ? void 0 : _state$domainStates$l4.msdyn_postconversationsurveymode) ?? PostChatSurveyMode.Embed;
  }
  return (_props$chatConfig3 = props.chatConfig) === null || _props$chatConfig3 === void 0 ? void 0 : (_props$chatConfig3$Li = _props$chatConfig3.LiveWSAndLiveChatEngJoin) === null || _props$chatConfig3$Li === void 0 ? void 0 : _props$chatConfig3$Li.msdyn_postconversationsurveymode;
};

// Set Survey mode based on conversation ended by entity
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setSurveyMode = async (props, participantType, state, dispatch) => {
  if (participantType === ParticipantType.User) {
    postChatSurveyMode = getUserSurveyMode(props, state);
    dispatch({
      type: LiveChatWidgetActionType.SET_SURVEY_MODE,
      payload: postChatSurveyMode
    });
    return;
  }
  if (participantType === ParticipantType.Bot) {
    postChatSurveyMode = getBotSurveyMode(props, state);
    dispatch({
      type: LiveChatWidgetActionType.SET_SURVEY_MODE,
      payload: postChatSurveyMode
    });
    return;
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const renderSurvey = async (postChatContext, dispatch) => {
  if (postChatSurveyMode === PostChatSurveyMode.Link) {
    setWidgetStateToInactive(dispatch);
    return;
  }
  if (postChatSurveyMode === PostChatSurveyMode.Embed) {
    await embedModePostChatWorkflow(postChatContext, dispatch);
  }
};

// Function for embed mode postchat workflow which is essentially same for both customer and agent
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const embedModePostChatWorkflow = async (postChatContext, dispatch) => {
  TelemetryHelper.logActionEvent(LogLevel.INFO, {
    Event: TelemetryEvent.EmbedModePostChatWorkflowStarted
  });
  if (postChatContext) {
    dispatch({
      type: LiveChatWidgetActionType.SET_CONVERSATION_STATE,
      payload: ConversationState.PostchatLoading
    });
    await addDelayInMs(Constants.PostChatLoadingDurationInMs);
    dispatch({
      type: LiveChatWidgetActionType.SET_CONVERSATION_STATE,
      payload: ConversationState.Postchat
    });
  } else {
    const error = `Conversation was Ended but App State was not set correctly: postChatContext = ${postChatContext}`;
    TelemetryHelper.logActionEvent(LogLevel.ERROR, {
      Event: TelemetryEvent.AppStatesException,
      ExceptionDetails: {
        exception: error
      }
    });
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initiatePostChat = async (props, conversationDetailsParam, state, dispatch, postchatContext) => {
  var _conversationDetails;
  conversationDetails = conversationDetailsParam;
  const participantType = ((_conversationDetails = conversationDetails) === null || _conversationDetails === void 0 ? void 0 : _conversationDetails.participantType) ?? postchatContext.participantType;
  await setSurveyMode(props, participantType, state, dispatch);
  await renderSurvey(postchatContext, dispatch);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isPostChatEnabled = (props, state) => {
  var _props$chatConfig4, _props$chatConfig4$Li, _state$domainStates$l5, _state$domainStates$l6;
  const isPostChatEnabled = ((_props$chatConfig4 = props.chatConfig) === null || _props$chatConfig4 === void 0 ? void 0 : (_props$chatConfig4$Li = _props$chatConfig4.LiveWSAndLiveChatEngJoin) === null || _props$chatConfig4$Li === void 0 ? void 0 : _props$chatConfig4$Li.msdyn_postconversationsurveyenable) ?? ((_state$domainStates$l5 = state.domainStates.liveChatConfig) === null || _state$domainStates$l5 === void 0 ? void 0 : (_state$domainStates$l6 = _state$domainStates$l5.LiveWSAndLiveChatEngJoin) === null || _state$domainStates$l6 === void 0 ? void 0 : _state$domainStates$l6.msdyn_postconversationsurveyenable);
  return isPostChatEnabled === Constants.true;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getPostChatContext = async (facadeChatSDK, state, dispatch) => {
  try {
    const postChatEnabled = await isPostChatSurveyEnabled(facadeChatSDK);
    if (postChatEnabled) {
      var _state$domainStates2;
      if ((state === null || state === void 0 ? void 0 : (_state$domainStates2 = state.domainStates) === null || _state$domainStates2 === void 0 ? void 0 : _state$domainStates2.postChatContext) === undefined) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = await facadeChatSDK.getPostChatSurveyContext();
        TelemetryHelper.logSDKEvent(LogLevel.INFO, {
          Event: TelemetryEvent.PostChatContextCallSucceed,
          Description: PostChatSurveyTelemetryMessage.PostChatContextCallSucceed
        });
        dispatch({
          type: LiveChatWidgetActionType.SET_POST_CHAT_CONTEXT,
          payload: context
        });
        return context;
      }
    }
  } catch (error) {
    TelemetryHelper.logSDKEvent(LogLevel.ERROR, {
      Event: TelemetryEvent.PostChatContextCallFailed,
      Description: PostChatSurveyTelemetryMessage.PostChatContextCallFailed
    });
  }
};

// Function for link mode postchat workflow which is essentially same for both customer and agent
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setWidgetStateToInactive = async dispatch => {
  dispatch({
    type: LiveChatWidgetActionType.SET_CONVERSATION_STATE,
    payload: ConversationState.InActive
  });
};
export { initiatePostChat, setWidgetStateToInactive, getPostChatContext, isPostChatEnabled as checkPostChatEnabled };